import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import { getOreV2ObjMap, oreAriseObj, oreV2Interface, oreV2ObjInterface, oreV2OccupyType } from "./oreV2Const";
import oreV2ObjItem from "./oreV2ObjItem";
import oreV2Select from "./oreV2Select";

const {ccclass, property} = cc._decorator;

@ccclass
export default class oreV2Item extends cc.Component {
    
    @property({type:cc.Node,displayName:"背景节点"})
    bgNode:cc.Node = null;
    
    @property({type:cc.Node,displayName:"mask节点"})
    maskNode:cc.Node = null;

    @property({type:cc.Node,displayName:"maskBgNode"})
    maskBgNode:cc.Node = null;

    @property({type:cc.Prefab,displayName:"物品预制体"})
    itemPrefab:cc.Prefab = null;

    @property({type:cc.SpriteFrame,displayName:"背景的节点"})
    bgSprties:cc.SpriteFrame[] = [];

    @property({type:cc.SpriteFrame,displayName:"mask节点图片"})
    maskSprites:cc.SpriteFrame[] = [];

    @property({type:cc.Node,displayName:"touchNode"})
    touchNode:cc.Node = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    private oreV2Data:oreV2Interface = null;

    oreV2Select:oreV2Select = null;

    smallPos:cc.Vec2[] = [
        cc.v2(-250,-40),
        cc.v2(240,20),
        cc.v2(280,-220),
        cc.v2(230,-540),
        cc.v2(-160,-580),
        cc.v2(-270,-440),
    ];

    centerPos:cc.Vec2[] = [
        cc.v2(-90,-200),
        cc.v2(30,-420)
    ]

    bigPos:cc.Vec2 = cc.v2(0,-250);

    start(){
        this.touchNode.on("touchmove",this.touchMove,this);
    }

    bindData(oreV2Data:oreV2Interface,oreV2Select:oreV2Select){
        this.oreV2Select = oreV2Select;
        this.oreV2Data = oreV2Data;
        this.loadItem();
    }

    loadItem(){
        let type = this.oreV2Data.type;
        let bgSprite:cc.SpriteFrame = null;
        let maskSprite:cc.SpriteFrame = null;
        switch(type){
            case 0:{
                bgSprite = this.bgSprties[0];
                maskSprite = this.maskSprites[0];
                break;
            }
            case 1:{
                bgSprite = this.bgSprties[2];
                maskSprite = this.maskSprites[2];
                break;
            }
            case 2:{
                bgSprite = this.bgSprties[1];
                maskSprite = this.maskSprites[1];
                break;
            }
        }
        this.bgNode.getComponent(cc.Sprite).spriteFrame = bgSprite;
        this.maskBgNode.getComponent(cc.Sprite).spriteFrame = maskSprite;
        let countRadio = this.oreV2Data.objCount;
        let count:number = Math.round(data_control.getRandNumberOfArrayTwo(countRadio));
        let objAry:oreV2ObjInterface[] = [];
        let isHasBig:boolean = false;
        let ariseObjAry:oreAriseObj[] = this.oreV2Data.hasObj;

        let weightAry:number[] = [];
        for(let i = 0;i<ariseObjAry.length;i++){
            let weight = ariseObjAry[i].weight;
            weightAry.push(weight);
        }
        if(this.oreV2Select.isPantied){
            count = 8;
        }

        for(let i =0;i<count;i++){
            let randObjIndex = data_control.getRandIPosByWeights(weightAry);
            let randAriseObj:oreAriseObj = ariseObjAry[randObjIndex];
            let randAriseObjId = randAriseObj.id;
            let randObj = getOreV2ObjMap()[randAriseObjId];
            while(randObj.occupyType == oreV2OccupyType.big && isHasBig){
                randObjIndex = data_control.getRandIPosByWeights(weightAry);
                randAriseObj = ariseObjAry[randObjIndex];
                randAriseObjId = randAriseObj.id;
                randObj = getOreV2ObjMap()[randAriseObjId];
            }

            if(this.oreV2Select.isPantied){
                randObj = getOreV2ObjMap()[1001];
            }

            if(randObj.occupyType == oreV2OccupyType.big){
                isHasBig = true;
            }
            objAry.push(randObj);
        }
        this.oreV2Select.setPatiend(false);
        let smallObjRandPosAry:cc.Vec2[] = [];
        if(isHasBig){
            smallObjRandPosAry = this.smallPos.concat();
        }else{
            smallObjRandPosAry = [].concat(this.smallPos.concat(),this.centerPos.concat());
        }
        smallObjRandPosAry = data_control.randomSortArray(smallObjRandPosAry);
        for(let i = 0;i<objAry.length;i++){
            let obj = objAry[i];
            let item = cc.instantiate(this.itemPrefab);
            let is = item.getComponent(oreV2ObjItem);
            is.bindData(obj);
            item.setParent(this.itemContent);
            if(obj.occupyType == oreV2OccupyType.big){
                item.setPosition(this.bigPos);
            }else{
                let randPos:cc.Vec2 = smallObjRandPosAry.pop();
                item.setPosition(randPos);
            }
        }
    }

    touchMove(e:cc.Event.EventTouch){
        if ( e.getTouches().length > 1 ) {
            //多点触控
            let point1Pos = e.getTouches()[0].getLocation();
            let point2Pos = e.getTouches()[1].getLocation();
            let delta0 = e.getTouches()[0].getPreviousLocation().sub( e.getTouches()[0].getLocation() );
            let delta1 = e.getTouches()[1].getPreviousLocation().sub( e.getTouches()[1].getLocation() );
            if ( delta0.y > 6 || delta1.y > 6 ) {
                let needAddY = delta0.y > delta1.y ? delta0.y : delta1.y;
                let needAddCount = Math.floor( needAddY / 6 );
                let j = 1;
                for ( let i = 1 ; i <= needAddY ; i += 6 ) {
                    let pointPos1Temp = point1Pos.add( delta0.div(needAddCount).mul( j ) );
                    let pointPos2Temp = point2Pos.add( delta0.div(needAddCount).mul( j ) );
                    this._addLine( this.maskNode.convertToNodeSpaceAR( pointPos1Temp ) ,this.maskNode.convertToNodeSpaceAR( pointPos2Temp ));
                    O1HD.emit("oreV2ObjItem.checkObjByLine" , pointPos1Temp , pointPos2Temp );
                    j ++;
                }
            }
            this._addLine( this.maskNode.convertToNodeSpaceAR( point1Pos ) ,this.maskNode.convertToNodeSpaceAR( point2Pos ));
        }else{
            //单点操作
            let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
            if ( distance > 20 ) {
                //补点操作
                for ( let num = 0 ; num < distance ; num += 20 ) {
                    let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                    let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                    this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                    O1HD.emit("oreV2ObjItem.checkObjByCircle" , actualLocation,25 );
                }
            }
            this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
        }
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
        // this.maskNode.getComponent(cc.Mask)._graphics;
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 40 );
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }

    _addLine( pos1:cc.Vec2 , pos2 : cc.Vec2 ){
        // @ts-ignore
        let graphics : cc.Graphics = this.maskNode.getComponent(cc.Mask)._graphics;
        graphics.lineWidth = 50;
        graphics.lineCap = cc.Graphics.LineCap.ROUND;
        graphics.strokeColor = cc.color( 20,20,20 );
        graphics.moveTo( pos1.x , pos1.y );
        graphics.lineTo( pos2.x , pos2.y );
        graphics.stroke();
    }

    onBtnBack(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
